import * as z from "zod/v4";

/**
 * Fetch the TypeScript type declarations (`Input` and `Output`) for an
 * extension contract, optionally narrowed by an inputSelector. Callers feed
 * the .d.ts text into a code editor as a tooltip / read-only reference so
 * authors know what shape they're writing against.
 */
export const getExtensionContractTypes = {
  name: "getExtensionContractTypes" as const,
  input: z.object({
    contractId: z.string(),
    inputSelector: z.array(z.string()).optional(),
  }),
  output: z.object({
    /** DTS for the current selector — what the artifact's Input actually is. */
    dts: z.string(),
    /** DTS for the full input universe — what's potentially available. */
    universeDts: z.string(),
    /** Top-level keys of the contract's input universe — for the selector picker. */
    topLevelKinds: z.array(z.string()),
  }),
};
